module.exports = __webpack_public_path__ + "img/crm.da518195.svg";